import { render, staticRenderFns } from "./CustomerContract.vue?vue&type=template&id=ab8b27ce"
import script from "./CustomerContract.vue?vue&type=script&lang=js"
export * from "./CustomerContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports